export default[
    {
        path: '/desligamento/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro do desligamento do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/boletins/tabela/lista',
        name: 'lista do boletim com tabela', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/boletins/tabela/editar/:id/:trabalhador_id',
        name: 'editar desligamento do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]